import { Box, IconButton, styled } from '@mui/material';

import { VAR_AREA_BOT } from '@mopla/constants';

export const RootContainer = styled(Box)({
	position: 'relative',
	height: '100%',
	width: '100%',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
});

export const BackgroundLayer = styled(Box)(({ theme }) => ({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	zIndex: 1,
	backgroundColor: theme.palette.neutral[40],
}));

export const AddressBlockSection = styled(Box)({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	zIndex: 100,
	paddingTop: 20,
	paddingLeft: 20,
	paddingRight: 20,
	display: 'flex',
	alignItems: 'center',
	gap: 16,
});

export const BackButtonWrapper = styled(Box)({
	flexShrink: 0,
});

export const AddressInputWrapper = styled(Box)({
	flex: 1,
	minWidth: 0,
});

export const StyledBackButton = styled(IconButton)(({ theme }) => ({
	width: 40,
	height: 40,
	backgroundColor: theme.palette.common.white,
	boxShadow: '6px 9px 28px 0px rgba(14, 28, 91, 0.1)',
	'&:hover': {
		backgroundColor: theme.palette.common.white,
	},
	'& .MuiSvgIcon-root': {
		fontSize: '20px',
		color: theme.palette.primary.main,
	},
}));

export const BottomSlotsContainer = styled(Box)({
	position: 'absolute',
	bottom: 0,
	left: 0,
	right: 0,
	zIndex: 100,
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
	paddingLeft: 16,
	paddingRight: 16,
	paddingBottom: `max(16px, ${VAR_AREA_BOT})`,
	'&:empty': {
		display: 'none',
	},
});
